export default __webpack_public_path__ + "static/media/timescaledb.650c6c6a.jpg";